module.exports = __webpack_public_path__ + "assets/img/modelo_stories_com_logo.e0b8eef1.png";